import { useState } from "react";
import { EditorSelectionModal } from ".";

export const useEditorSelectionModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  return {
    modalElement: (
      <EditorSelectionModal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      />
    ),
    openModal: (event?: React.MouseEvent) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      setIsOpen(true);
    },
  };
};
